import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter } from 'lucide-react';
import Logo from './Logo';

const TikTokIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/>
  </svg>
);

const socials = [
  { icon: <Instagram size={18} />, href: 'https://www.instagram.com/veridriveus/', label: 'Instagram' },
  { icon: <Twitter size={18} />,   href: 'https://x.com/Veridrive',               label: 'X / Twitter' },
  { icon: <TikTokIcon />,          href: 'https://www.tiktok.com/@veridrive',      label: 'TikTok' },
];

export default function Footer() {
  return (
    <footer style={{ background: 'var(--navy-dark)', borderTop: '1px solid rgba(255,255,255,0.06)', padding: '40px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 24 }}>

        <a href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 }}>
          <Logo size={28} />
          <span style={{ fontFamily: 'Inter', fontWeight: 800, fontSize: 15, color: 'white', letterSpacing: '0.06em' }}>
            VERI<span style={{ color: 'var(--gold)' }}>DRIVE</span>
          </span>
        </a>

        <div style={{ display: 'flex', gap: 28, flexWrap: 'wrap' }}>
          {['Services', 'How It Works', 'Nigeria Export', 'Find My Car', 'Contact'].map(l => (
            <a key={l} href={`/#${l.toLowerCase().replace(/ /g, '-')}`} className="nav-link" style={{ fontSize: 13 }}>{l}</a>
          ))}
          <Link to="/careers" className="nav-link" style={{ fontSize: 13 }}>Careers</Link>
        </div>

        <div style={{ display: 'flex', gap: 12 }}>
          {socials.map(({ icon, href, label }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noreferrer"
              aria-label={label}
              style={{
                width: 36, height: 36, borderRadius: 8,
                background: 'rgba(255,255,255,0.07)',
                border: '1px solid rgba(255,255,255,0.1)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'rgba(255,255,255,0.6)',
                transition: 'background 0.2s, color 0.2s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'var(--gold)'; e.currentTarget.style.color = 'var(--navy-dark)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.07)'; e.currentTarget.style.color = 'rgba(255,255,255,0.6)'; }}
            >
              {icon}
            </a>
          ))}
        </div>

        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', width: '100%', textAlign: 'center', borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: 20, marginTop: 4 }}>
          © 2026 VeriDrive · Seattle, WA · veridrive.autos
        </div>
      </div>
    </footer>
  );
}
